module.exports = __webpack_public_path__ + "static/media/zoleWon_75_100.7850d227.png";